import React, { useEffect, useState } from 'react';
import { Dimensions, Modal, TouchableOpacity, View } from 'react-native';
import { Icon } from "../icon/Icon";
import ThemeProvider from "@voltmoney/theme";
import { ColorTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
export var BottomSheetAnimation;
(function (BottomSheetAnimation) {
    BottomSheetAnimation["SLIDE"] = "slide";
    BottomSheetAnimation["FADE"] = "fade";
    BottomSheetAnimation["NONE"] = "none";
})(BottomSheetAnimation || (BottomSheetAnimation = {}));
const BottomSheetMf = ({ children = React.createElement(React.Fragment, null), modalVisible = false, onModalClose, onModalOpen, showClose = true, onClosePress, backgroundColor, animationType = BottomSheetAnimation.SLIDE, isFromSDKProcessingCard = false, headerChild }) => {
    const [_modalVisible, setModalVisible] = useState(false);
    const [_backgroundColor, setBackgroundColor] = useState(undefined);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const screenWidth = Dimensions.get('window').width;
    const isLargeScreen = screenWidth >= 769;
    useEffect(() => {
        if (modalVisible === true) {
            openModal();
        }
        else {
            closeModal();
        }
    }, [modalVisible]);
    useEffect(() => {
        setBackgroundColor(backgroundColor);
    }, [backgroundColor]);
    const openModal = () => {
        setModalVisible(true);
        onModalOpen &&
            onModalOpen();
    };
    const closeModal = () => {
        setModalVisible(false);
        onModalClose &&
            onModalClose();
    };
    return (React.createElement(View, null,
        React.createElement(Modal, { visible: _modalVisible, animationType: animationType, transparent: true, presentationStyle: "overFullScreen", onRequestClose: closeModal },
            React.createElement(View, { style: {
                    flex: 1,
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement(View, { style: [{
                            marginTop: isLargeScreen ? 84 : 0,
                            marginBottom: isLargeScreen ? 28 : 0,
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            flex: 1,
                            width: isLargeScreen ? 508 : '100%',
                            backgroundColor: _backgroundColor ? _backgroundColor : 'rgba(0, 0, 0, 0.5)',
                        }] },
                    React.createElement(View, { style: {
                            width: '100%',
                            backgroundColor: 'white',
                            padding: 16,
                            borderTopRightRadius: 10,
                            borderTopLeftRadius: 10
                        } },
                        showClose &&
                            React.createElement(View, { style: {
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: headerChild ? 'space-between' : 'flex-end',
                                } },
                                headerChild,
                                isFromSDKProcessingCard ?
                                    React.createElement(TouchableOpacity, { style: {
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            position: 'relative',
                                        }, onPress: () => {
                                            onClosePress &&
                                                onClosePress();
                                            closeModal();
                                        } },
                                        React.createElement(Icon, { name: IconTokens.Cancel, size: IconSizeTokens.XXXL, color: ColorTokens.Grey_Night }))
                                    : React.createElement(TouchableOpacity, { style: {
                                            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
                                            padding: 4,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: 24,
                                            height: 24,
                                            position: 'relative',
                                            borderRadius: 100
                                        }, onPress: () => {
                                            onClosePress &&
                                                onClosePress();
                                            closeModal();
                                        } },
                                        React.createElement(Icon, { name: IconTokens.SYSTEM_CANCEL_DLS, size: IconSizeTokens.LG, color: ColorTokens.Grey_Night }))),
                        children))))));
};
export default BottomSheetMf;
